import React, { FunctionComponent, useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./styles.scss";
import { Icon } from "../../../Icon";
import { useAuth } from "../../../../utils/hooks/useIsAuth";

import Button from "../../../common/Button";
import { UserContext } from "../../../../context/UserContext";
import { deleteCookie } from "../../../../utils/cookies";

type Props = {
  handleClose: () => void;
};
const SectionsModal: FunctionComponent<Props> = ({ handleClose }) => {
  const { user } = useContext(UserContext);
  const userName = user?.name;
  const email = user?.email;
  const navigate = useNavigate();
  const location = useLocation();
  const handleNavigate = (route: string) => {
    handleClose();
    navigate(route);
  };

  const { isAuth, setIsAuth } = useAuth();

  const handleLogout = () => {
    try {
      deleteCookie("accessToken");
      deleteCookie("refreshToken");
      setIsAuth(false);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  const sections = [
    { title: "Cadenas", route: "/category/chain" },
    { title: "Pulseras", route: "/category/brazalete" },
    { title: "Dijes", route: "/category/pendant" },
    { title: "Anillos", route: "/category/ring" },
    { title: "Aros", route: "/category/hoop" },
    { title: "Fornituras", route: "/category/finding" },
    { title: "Nosotros", route: "/about-us" },
    { title: "Contacto", route: "/contact" },
  ];

  return (
    <section className="sections-modal">
      <header className="sections-modal__header">
        <Icon iconName="rtabak_white_icon" className="sections-modal__logo" />
        <div onClick={handleClose} className="sections-modal__close">
          <Icon iconName="close_icon" className="sections-modal__close__icon" />
        </div>
      </header>
      <div className="sections-modal__main">
        <div className="sections-modal__body">
          {!isAuth ? (
            <div className="sections-modal__auth">
              <Button
                modifier="secondary"
                onClick={() => {
                  handleClose();
                  navigate("/login", { state: { from: location.pathname } });
                }}
                className="sections-modal__button"
              >
                Iniciar sesión
              </Button>
              <div
                onClick={() => handleNavigate("/sign-up")}
                className="sections-modal__auth__sign-up"
              >
                <Button modifier="fourth" className="sections-modal__button">
                  Registrarse
                </Button>
              </div>
            </div>
          ) : (
            <div className="sections-modal__user">
              <div className="sections-modal__user__info">
                {userName && email && (
                  <>
                    <p className="sections-modal__user__info__name">
                      {userName}
                    </p>
                    <p className="sections-modal__user__info__email">{email}</p>
                  </>
                )}
              </div>
              <Button
                onClick={() => handleNavigate("/edit-profile")}
                modifier="fourth"
                className="sections-modal__button sections-modal__button--edit"
              >
                Editar perfil
              </Button>
            </div>
          )}
          <div className="sections-modal__sections">
            {sections.map((section, index) => (
              <div
                key={index}
                onClick={() => handleNavigate(`${section.route}`)}
                className="sections-modal__section"
              >
                <p className="sections-modal__section__text">{section.title}</p>
              </div>
            ))}
          </div>
        </div>
        {isAuth && (
          <div className="sections-modal__logout">
            <Button
              modifier="fourth"
              className=" sections-modal__button sections-modal__logout__button"
              onClick={handleLogout}
            >
              Cerrar sesión
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};

export default SectionsModal;
